import { render, staticRenderFns } from "./ViewTemplateDetails.vue?vue&type=template&id=70891b31&scoped=true"
import script from "./ViewTemplateDetails.vue?vue&type=script&lang=js"
export * from "./ViewTemplateDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewTemplateDetails.vue?vue&type=style&index=0&id=70891b31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70891b31",
  null
  
)

export default component.exports